/* istanbul ignore file */
import useFieldHelper from '../fieldHelper';
import { FieldProps } from '../types';
import SearchResultField from './SearchResultField';
/* This is temporary component made to highlight email in list, must be replaced with regular email field when global search implemented */
import React from 'react';
import { useUiTheme } from 'framework/uiTheme';

const EmailSearchField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { BaseFieldLayout } = useUiTheme();

  const { realValue } = props;
  const value = getValue();
  const linkValue = realValue || value;

  const passedValue = value ? (
    <a href={`mailto:${linkValue}`}>
      <SearchResultField value={value} />
    </a>
  ) : null;

  return <BaseFieldLayout value={passedValue} label={getLabel()} />;
};

export default EmailSearchField;
